import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { BillingToggle, PricingCards, TIERS, type BillingCycle } from "./PricingCards";

/** Aperçu des offres sur l'accueil ; le détail vit sur /tarifs. */
export function PricingTeaser() {
  const [cycle, setCycle] = useState<BillingCycle>("monthly");
  return (
    <section id="tarifs-apercu" className="border-y border-border bg-surface py-24 lg:py-32">
      <div className="mx-auto max-w-[1200px] px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-end">
          <SectionHeading
            eyebrow="Tarifs"
            title="Un prix lisible, selon votre équipe."
            lead={`Commencez avec Découverte : ${TIERS[0].users} utilisateur et ${TIERS[0].invoices} factures actives, gratuitement et sans carte bancaire. Pour davantage de volume, choisissez une offre adaptée à votre activité.`}
          />
          <BillingToggle cycle={cycle} onChange={setCycle} />
        </div>
        <div className="mt-12">
          <PricingCards cycle={cycle} tiers={TIERS.slice(1)} />
        </div>
        <Link
          to="/tarifs"
          className="group mt-10 inline-flex min-h-11 cursor-pointer items-center gap-2 rounded-lg text-[15px] font-semibold text-action hover:text-action-strong focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
        >
          Comparer les offres, dont Découverte et Sur mesure
          <ArrowRight
            aria-hidden
            className="size-4 transition-transform duration-150 group-hover:translate-x-0.5"
          />
        </Link>
      </div>
    </section>
  );
}
